import { apiRequest } from '@/lib/api';

export type ReportsDateRange = 'this_month' | 'last_30_days' | 'this_quarter' | 'custom';
export type PendingAgingMode = 'count' | 'value';

export type ReportsOverview = {
  filters: {
    projectId?: string | null;
    dateRange: ReportsDateRange;
    startDate: string;
    endDate: string;
    pendingAgingMode: PendingAgingMode;
  };
  currencyCode: string;
  kpis: {
    avgApprovalTimeDays: number;
    approvalRate: number;
    pendingRate: number;
    pendingValue: number;
    needsClarificationValue: number;
    rejectionRate: number;
    approvedValue: number;
    approvedCount: number;
    pendingCount: number;
    rejectedCount: number;
    avgWorkHoursPerDay: number;
    avgProjectsPerDay: number;
    projectStatusCounts: {
      active: number;
      onHold: number;
      completed: number;
      cancelled: number;
    };
  };
  charts: {
    ticketTypeDistribution: Array<{
      key: 'TM_TICKET' | 'CHANGE_ORDER' | 'EXTRA_WORK';
      label: string;
      count: number;
    }>;
    collectedPaymentsTrend: Array<{
      key: string;
      label: string;
      total: number;
      cash: number;
      check: number;
      card: number;
      zelle: number;
      ach: number;
      other: number;
    }>;
  };
  topPendingTickets: Array<{
    id: string;
    ticketNumber: string;
    title: string;
    value: number;
    agingDays: number;
    project: { id: string; name: string };
    client?: { id: string; name: string } | null;
    approvalRequestId?: string | null;
    recipientName?: string | null;
    recipientEmail?: string | null;
    lastReminderAt?: string | null;
  }>;
  hasData: boolean;
};

export function fetchReportsOverview(filters: {
  projectId?: string;
  dateRange: ReportsDateRange;
  pendingAgingMode: PendingAgingMode;
  startDate?: string;
  endDate?: string;
}) {
  const query = new URLSearchParams();
  query.set('dateRange', filters.dateRange);
  query.set('pendingAgingMode', filters.pendingAgingMode);
  if (filters.projectId) query.set('projectId', filters.projectId);
  if (filters.startDate) query.set('startDate', filters.startDate);
  if (filters.endDate) query.set('endDate', filters.endDate);

  return apiRequest<ReportsOverview>(`/reports/overview?${query.toString()}`, {
    method: 'GET',
  });
}
